import { Alert } from '@mui/material'
import React from 'react'
import useLocale from '../../utils/locale/locale.hook'

const SetupComponent = (props) => {
    const locale = useLocale()
    return <Alert severity="warning">{locale?.['setup']}</Alert>
}
export default SetupComponent
